import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { Button } from "../components/ui/button";
import { Card } from "../components/ui/card";

// An address that leads nowhere (Ordre 24-4): the person stays inside the CRM, told plainly, with the way back.
export default function NotFound() {
  return (
    <div className="flex justify-center py-10" data-testid="not-found-page">
      <Card className="max-w-md w-full p-8 text-center space-y-3">
        <Compass className="mx-auto text-slate-300" size={32} aria-hidden />
        <h1 className="font-display font-semibold text-lg text-slate-900">Cette page n'existe pas</h1>
        <p className="text-sm text-slate-500">Le lien est peut-être ancien ou mal recopié. Vous pouvez revenir au tableau de bord ou chercher ce que vous voulez avec la recherche en haut de l'écran.</p>
        <Button asChild><Link to="/dashboard">Retour au tableau de bord</Link></Button>
      </Card>
    </div>
  );
}
